var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b;
import * as React from 'react';
import { DVSClientClass, getDefaultEdgeUrl } from '@doordash/lib-dvs-client';
import { DVSClientProvider } from '@doordash/lib-dvs-client/lib/react';
import { getTelemetryInstance } from '../../utils/useTelemetry';
import { useGetConsumerAndTeamInfo } from './useGetConsumerAndTeamInfo';
import { isLocalEnvironment } from '@doordash/lib-environment';
export var DV2_NAMES = {
    ddfwDV2Test: 'ddfwDV2Test',
    ddfwBudgetReminder: 'ddfwBudgetReminder',
    ddfwOptInLinks: 'ddfwOptInLinks',
    ddfwItemizedReceipts: 'ddfwItemizedReceipts',
    ddfwSelfServeProductOptionsVersion: 'ddfwSelfServeProductOptionsVersion',
    ddfwHideTalktoSalesModule: 'ddfwHideTalktoSalesModule',
    ddfwAllowCreateBudgetPlaceOrder: 'ddfwAllowCreateBudgetPlaceOrder',
    ddfwMembershipActivationReminder: 'ddfwMembershipActivationReminder',
    ddfwSelfServeEmOnboarding: 'ddfwSelfServeEmOnboarding',
    ddfwContactSalesPage: 'ddfwContactSalesPage',
};
export var dv2Defaults = (_a = {},
    _a[DV2_NAMES.ddfwDV2Test] = false,
    _a[DV2_NAMES.ddfwBudgetReminder] = false,
    _a[DV2_NAMES.ddfwOptInLinks] = false,
    _a[DV2_NAMES.ddfwItemizedReceipts] = false,
    _a[DV2_NAMES.ddfwHideTalktoSalesModule] = false,
    _a[DV2_NAMES.ddfwMembershipActivationReminder] = false,
    _a[DV2_NAMES.ddfwContactSalesPage] = false,
    _a);
// Created as a separate object so we do not have to cast all existing experiments to boolean
export var dv2DefaultsNonBoolean = (_b = {},
    // Product Options Version Experiment
    // 1 - Product Options V2 (EM, DP, GC) --- Deprecated
    // 2 - Quiz
    // 3 - Product Options V3 (Catering, EM, GC) --- Deprecated
    // 4 - Quiz V2 (display all products on recommendation page)
    _b[DV2_NAMES.ddfwSelfServeProductOptionsVersion] = 1,
    // Place Order experiment
    // 0 - no "Place an Order" button
    // 1 - "Place an Order" at the top of the menu items (aka Kaiser experiment)
    // 2 - "Place an Order" at the bottom of the menu items
    _b[DV2_NAMES.ddfwAllowCreateBudgetPlaceOrder] = 0,
    // Self Serve EM Onboarding experiment
    // 1 - regular onboarding with 1-2-3 steps
    // 2 - selection between Fast and Advanced onboarding experience
    _b[DV2_NAMES.ddfwSelfServeEmOnboarding] = 1,
    _b);
export var DVSClient = new DVSClientClass(process.env.NODE_ENV === 'QA'
    ? {
        // Point to DV2 development environment when in QA
        dvsEdgeUrl: getDefaultEdgeUrl('development'),
    }
    : {});
export var PortalDVSClientProvider = function (_a) {
    var children = _a.children;
    var context = useGetConsumerAndTeamInfo();
    DVSClient.init({
        application: 'app-corp-consumer-portal',
        appVersion: isLocalEnvironment() ? 'development' : process.env.APP_VERSION,
        exposuresEnabled: false,
        os: 'web',
        namespaces: ['app-corp-consumer-portal'],
        telemetry: getTelemetryInstance(),
    });
    React.useEffect(function () {
        DVSClient.evaluate(__assign({}, context));
    }, [context]);
    return React.createElement(DVSClientProvider, { client: DVSClient }, children);
};
export default PortalDVSClientProvider;
